import { render, staticRenderFns } from "./sleep-period.vue?vue&type=template&id=04d460a8&scoped=true"
import script from "./sleep-period.vue?vue&type=script&lang=js"
export * from "./sleep-period.vue?vue&type=script&lang=js"
import style0 from "./sleep-period.vue?vue&type=style&index=0&id=04d460a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d460a8",
  null
  
)

export default component.exports